// function that will format query string to be
// value=category&value=category
export const FormatFiltersQuery = (selectedFilters) => {
	let filtersQuery = "&";
	selectedFilters.map((taxonomyObj, index) => {
		filtersQuery = filtersQuery.concat(`${taxonomyObj.category}=${taxonomyObj.value}${index == selectedFilters.length - 1 ? "" : "&"}`);
	});

	return filtersQuery;
};